import { render, staticRenderFns } from "./NewItemTestMethod.vue?vue&type=template&id=020f3f7e&scoped=true&"
import script from "./NewItemTestMethod.vue?vue&type=script&lang=js&"
export * from "./NewItemTestMethod.vue?vue&type=script&lang=js&"
import style0 from "./NewItemTestMethod.vue?vue&type=style&index=0&id=020f3f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f3f7e",
  null
  
)

export default component.exports